export const CONTACTS = "CONTACTS";
export const CONTACTS_LOADING = "CONTACTS_LOADING";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_IS_SENDING = "FEEDBACK_IS_SENDING";
